var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Eid'),_c('h1',[_vm._v("كل عام وأنتم بخير")]),_c('AppForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }